import { PanelToggle } from 'mailup-web-components'
import { taskState } from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const EnableDisable = () => {
  const intl = useIntl()
  const [{ Enabled }, setTaskState] = useRecoilState(taskState)

  const onChangeToggle = ({ target: { checked } }) => {
    setTaskState((prev) => ({
      ...prev,
      Enabled: !prev.Enabled,
      isDirty: true
    }))
  }

  return (
    <PanelToggle
      data-mu-test='task-5-enable-disable'
      title={intl.formatMessage({ id: 'Load.Task.ReviewActivate' })}
      checked={Enabled}
      onChange={onChangeToggle}
    />
  )
}

export default EnableDisable
